import { Eye, EyeOff, Settings } from 'lucide-react'

import { CommandProps } from '~/components/command-menu/types'
import { settingsVisibility } from '~/components/settings/utils'
import { usePrivacyModeStore } from '~/store/privacyModeStore'
import { sendTrackingData } from '~/utils/tracking'

export const settingsCommands: CommandProps[] = [
  {
    category: 'settings',
    label: () =>
      usePrivacyModeStore.getState().isPrivacyModeOn
        ? 'Show amounts and addresses'
        : 'Hide amounts and addresses',
    value: () => 'Settings - Privacy mode',
    icon: () =>
      usePrivacyModeStore.getState().isPrivacyModeOn ? <Eye /> : <EyeOff />,
    onSelect: ({ actions: { setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'toggle_privacy_mode',
      })

      usePrivacyModeStore.getState().toggle()

      setActiveView(null)
    },
    shortcuts: ['h'],
  },
  {
    category: 'settings',
    label: () => 'General',
    value: () => 'Settings - General',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_general_settings',
      })

      navigate('/settings/team/general')

      setActiveView(null)
    },
    shortcuts: ['g > comma'],
    isDisabled: ({ orgMember }) =>
      settingsVisibility.general === 'owners' && orgMember?.role !== 'OWNER',
  },
  {
    category: 'settings',
    label: () => 'Members',
    value: () => 'Settings - Members',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_members_settings',
      })

      navigate('/settings/team/members')

      setActiveView(null)
    },
    isDisabled: ({ orgMember }) =>
      settingsVisibility.members === 'owners' && orgMember?.role !== 'OWNER',
  },
  {
    category: 'settings',
    label: () => 'Networks',
    value: () => 'Settings - Networks',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_networks_settings',
      })

      navigate('/settings/team/networks')

      setActiveView(null)
    },
    isDisabled: ({ orgMember }) =>
      settingsVisibility.networks === 'owners' && orgMember?.role !== 'OWNER',
  },
  {
    category: 'settings',
    label: () => 'Recovery',
    value: () => 'Settings - Recovery',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_recovery_settings',
      })

      navigate('/settings/team/recovery')

      setActiveView(null)
    },
    isDisabled: ({ orgMember }) =>
      settingsVisibility.recovery === 'owners' && orgMember?.role !== 'OWNER',
  },
  {
    category: 'settings',
    label: () => 'Tokens',
    value: () => 'Settings - Tokens',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_tokens_settings',
      })

      navigate('/settings/team/tokens')

      setActiveView(null)
    },
    isDisabled: ({ orgMember }) =>
      settingsVisibility.tokens === 'owners' && orgMember?.role !== 'OWNER',
  },
  {
    category: 'settings',
    label: () => 'Banks',
    value: () => 'Settings - Banks',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_banks_settings',
      })

      navigate('/settings/team/banks')

      setActiveView(null)
    },
    isDisabled: ({ orgMember }) =>
      settingsVisibility.banks === 'owners' && orgMember?.role !== 'OWNER',
  },
  {
    category: 'settings',
    label: () => 'Profile',
    value: () => 'Settings - Profile',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_personal_settings',
      })

      navigate('/settings/personal/profile')

      setActiveView(null)
    },
  },
  {
    category: 'settings',
    label: () => 'Signing keys',
    value: () => 'Settings - Signing keys',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_passkeys_settings',
      })

      navigate('/settings/personal/signing-keys')

      setActiveView(null)
    },
  },
  {
    category: 'settings',
    label: () => 'Notifications',
    value: () => 'Settings - Notifications',
    icon: () => <Settings />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'settings',
        item: 'open_notification_settings',
      })

      navigate('/settings/personal/notifications')

      setActiveView(null)
    },
  },
]
